import React from 'react';
import { 
  Backdrop, 
  Box, 
  CircularProgress, 
  Typography, 
  LinearProgress 
} from '@mui/material';
import { format, parseISO } from 'date-fns';
import { getPendingDaysCount } from '../utils/dateUtils';

export default function R0006LoadingOverlay({
  pageLoading,
  loadingProgress,
  loadingMessage,
  pendingSelection,
  selectedArea
}) {

  if (!pageLoading) {
    return null;
  }


  return (
    <Backdrop
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: (theme) => theme.zIndex.modal + 1,
        backgroundColor: 'rgba(44, 62, 80, 0.85)',
        backdropFilter: 'blur(4px)'
      }}
      open={pageLoading} // 🚨 This should be true when loading
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        gap={4}
        p={6}
        sx={{
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          borderRadius: 3,
          minWidth: 400,
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)'
        }}
      >
        <CircularProgress 
          size={80} 
          thickness={3}
          sx={{ color: '#2c3e50' }}
        />
        
        <Box textAlign="center" minWidth={300}>
          <Typography variant="h5" fontWeight="bold" color="#2c3e50" mb={1}>
            Loading Report Data
          </Typography>
          <Typography variant="body1" color="text.secondary" mb={3}>
            {loadingMessage || 'Processing...'}
          </Typography>
          
          <Box mb={2}>
            <LinearProgress 
              variant="determinate" 
              value={loadingProgress || 0} 
              sx={{
                height: 8,
                borderRadius: 4,
                backgroundColor: '#e0e0e0',
                '& .MuiLinearProgress-bar': {
                  backgroundColor: '#2c3e50',
                  borderRadius: 4
                }
              }}
            />
          </Box>
          
          <Typography variant="body2" color="text.secondary" mb={3}>
            {Math.round(loadingProgress || 0)}% complete
          </Typography>
          
          {pendingSelection && (
            <Box p={3} bgcolor="#f8f9fa" borderRadius={2}>
              <Typography variant="h6" color="#2c3e50" mb={1}>
                {format(parseISO(pendingSelection.startDate), 'MMM dd')} - {' '}
                {format(parseISO(pendingSelection.endDate), 'MMM dd, yyyy')}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Processing {getPendingDaysCount(pendingSelection)} {getPendingDaysCount(pendingSelection) === 1 ? 'day' : 'days'} of efficiency data for {selectedArea}
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    </Backdrop>
  );
}